import { render, staticRenderFns } from "./PageGoods.vue?vue&type=template&id=038b2f3a&scoped=true&"
import script from "./PageGoods.vue?vue&type=script&lang=js&"
export * from "./PageGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b2f3a",
  null
  
)

export default component.exports